import {openDialog} from 'platform/components';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {WarrantyProgramForm} from '../components/WarrantyProgramForm';
import {WARRANTY_PROGRAM_FORM_DIALOG_ID} from '../constants/WARRANTY_PROGRAM_FORM_DIALOG_ID';

export const openWarrantyProgramFormDialog = (warrantyProgramId?: string) =>
  openDialog(
    <WarrantyProgramForm
      warrantyProgramId={warrantyProgramId}
      data-testid={testIds.settings.warranty(
        isNil(warrantyProgramId) ? 'addProgram' : 'editProgram'
      )}
    />,
    {
      id: WARRANTY_PROGRAM_FORM_DIALOG_ID,
      title: i18n.t('entity.warranty.labels.warrantyProgram'),
      'data-testid': testIds.settings.warranty(
        isNil(warrantyProgramId) ? 'addProgramDialog' : 'editProgramDialog'
      ),
    }
  );
